import React from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { NoState } from "../models/interfaces"
import Ueberweisung from "../models/ueberweisung"
import { FeatureService } from "../services/FeatureService"

interface UeberweisungViewProps {
    key: number
    index: number
    ueberweisung: Ueberweisung
    t?: any
}

export class UeberweisungView extends React.Component<UeberweisungViewProps, NoState> {
    onChange(element: string, value: any) {
        EventBus.instance.emit("changeProperty", `zahlungsdaten.ueberweisung.${this.props.index}.${element}`, value)
    }

    onRemoveClicked = () => {
        EventBus.instance.emit("removeUeberweisung", this.props.index)
    }

    render() {
        const { t } = this.props
        const disabled = FeatureService.isFeatureActive("DEMO")
        return (
            <div className="ueberweisung">
                {
                    // generated code below - changes will be overwritten on next generation cycle
                }

                <Components.FormGroup label={t("rechnung.zahlungsdaten.ueberweisung.iban.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.zahlungsdaten.ueberweisung.iban.placeholder")}
                        onChange={this.onChange.bind(this, "iban")}
                        value={this.props.ueberweisung.iban}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.zahlungsdaten.ueberweisung.kontoinhaber.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.zahlungsdaten.ueberweisung.kontoinhaber.placeholder")}
                        onChange={this.onChange.bind(this, "kontoinhaber")}
                        value={this.props.ueberweisung.kontoinhaber}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.zahlungsdaten.ueberweisung.bic.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.zahlungsdaten.ueberweisung.bic.placeholder")}
                        onChange={this.onChange.bind(this, "bic")}
                        value={this.props.ueberweisung.bic}
                    />
                </Components.FormGroup>

                {
                    // generated code above - changes will be overwritten on next generation cycle
                }
                <Components.Row>
                    <Components.Col align={Components.Align.RIGHT}>
                        <Components.Button
                            style={Components.ButtonStyle.SECONDARY}
                            label={t("rechnung.zahlungsdaten.ueberweisung.loeschen")}
                            onClick={this.onRemoveClicked}
                            disabled={disabled}
                            tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                            tooltipAtDisabled={disabled}
                        />
                    </Components.Col>
                </Components.Row>
            </div>
        )
    }
}
